import axios from '@/utils/request';
import { AxiosRequestConfig } from 'axios';

type ToPost<T> = Omit<T, '_id'>;

interface Banner {
  _id: string;
  name: string;
  restriction?: {
    width: number;
    height: number;
  };
  page?: {
    name: string;
    bannerName: string;
  };
}

export interface BannerItem {
  _id: string;
  imagePath: string;
  imageURL: string;
  href: string;
  title?: string;
  description?: string;
}

export interface BannerInList extends Banner {
  cntItems: number;
}

export interface BannerWithItems extends Banner {
  items: BannerItem[];
}

async function request(options: AxiosRequestConfig) {
  const res = await axios(options);
  return res.data;
}

export function postBanner(data: ToPost<Banner>) {
  return request({
    url: '/banners',
    method: 'post',
    data,
  });
}

export function getBanners(): Promise<BannerInList[]> {
  return request({
    url: '/banners',
    method: 'get',
  });
}

export function getBanner(idOrName: string): Promise<BannerWithItems> {
  return request({
    url: `/banners/${idOrName}`,
    method: 'get',
  });
}

export function replaceBanner(id: string, data: ToPost<Banner>) {
  return request({
    url: `/banners/${id}`,
    method: 'patch',
    data,
  });
}

export function deleteBanner(id: string) {
  return request({
    url: `/banners/${id}`,
    method: 'delete',
  });
}

export function postBannerItem(
  id: string,
  { imagePath, href, title, description }: ToPost<Omit<BannerItem, 'imageURL'>>,
) {
  return request({
    url: `/banners/${id}/items`,
    method: 'post',
    data: {
      imagePath,
      href,
      title: title || undefined,
      description: description || undefined,
    },
  });
}

export function replaceBannerItem(
  id: string,
  itemId: string,
  data: ToPost<Omit<BannerItem, 'imageURL'>>,
) {
  return request({
    url: `/banners/${id}/items/${itemId}`,
    method: 'put',
    data,
  });
}

export function deleteBannerItem(id: string, itemId: string) {
  return request({
    url: `/banners/${id}/items/${itemId}`,
    method: 'delete',
  });
}
